import {Controller} from "@hotwired/stimulus"
import {get} from "@rails/request.js";


export default class extends Controller {
  static targets = ["vdcNameInput", "edgeGatewayNameInput", "providerInput", "organizationNameInput"];

  connect() {
  }

  updateValues(event) {
    const rickNumber = this.organizationNameInputTarget.value;

    this.updateVdcName(event)
    this.edgeGatewayNameInputTarget.value = rickNumber + '-edge01';
  }

  updateVdcName(event) {
    const rickNumber = this.organizationNameInputTarget.value;

    const selectedOption = this.providerInputTarget.selectedOptions[0];
    const location = selectedOption.getAttribute('data-location');
    this.vdcNameInputTarget.value = rickNumber + '_' + location + '-vdc01'
  }

}

